/**
 * Modifier Lookup Tables (SF-63)
 *
 * Frontend constants mirroring backend Property system values.
 * These must be kept in sync with InMemoryPropertySystem.java.
 *
 * IMPORTANT: When InMemoryPropertySystem balance values change, update these constants.
 * See CLAUDE.md for sync requirements.
 */

/**
 * Honor title income modifiers (Property.INCOME_MOD)
 */
export const HONOUR_INCOME_MOD: Record<string, number> = {
  PEASANT: 1.0,
  KNIGHT: 1.0,
  LORD: 1.02,
  BARON: 1.04,
  VISCOUNT: 1.06,
  COUNT: 1.10,
  MARQUIS: 1.14,
  DUKE: 1.18,
  PRINCE: 1.22,
};

/**
 * Science school bonuses
 */
export const ALCHEMY_INCOME_MOD = 1.4;

/**
 * Spell effect modifiers
 */
export const PLAGUE_INCOME_MOD = 0.85;
export const RIOT_INCOME_MOD = 0.80;
export const FERTILE_LANDS_PRODUCTION_MOD = 1.25;
export const DROUGHT_PRODUCTION_MOD = 0.75;
export const INSPIRE_ARMY_WAGE_MOD = 0.85;
export const GREED_WAGE_MOD = 1.25;

/**
 * Monarch bonuses
 */
export const MONARCH_FOOD_PRODUCTION_MOD = 1.10;

/**
 * Kingdom stance modifiers
 */
export const STANCE_MILITARY_WAGE_MOD: Record<string, number> = {
  DEFENSIVE: 1.0,
  NEUTRAL: 1.0,
  AGGRESSIVE: 1.30,
};

/**
 * Wage rates (gc per unit per tick)
 */
export const WAGE_PER_SOLDIER = 0.5;
export const WAGE_PER_SPECIALIST = 1.0; // offense/defense units
export const WAGE_PER_ELITE = 1.5;
export const WAGE_PER_THIEF = 0.75;

/**
 * Base income rates (gc per peasant per tick)
 */
export const MONEY_PER_EMPLOYED = 2.75;
export const MONEY_PER_UNEMPLOYED = 0.75;
export const MONEY_PER_BANK = 0.02; // Percentage bonus per bank (2%)

/**
 * NOTE: Race and Personality income modifiers are listed in GAME_MECHANICS.md
 * but are NOT yet wired into the active EconomySystem.getIncomeModifier().
 * They exist only in the unused ProductionSystem.
 *
 * When the backend is fixed, uncomment these:
 *
 * export const RACE_INCOME_MOD: Record<string, number> = {
 *   HUMAN: 1.0,
 *   ELF: 1.1,
 *   DWARF: 1.0,
 *   ORC: 1.05,
 *   HALFLING: 1.0,
 *   UNDEAD: 1.0,
 * };
 *
 * export const PERSONALITY_INCOME_MOD: Record<string, number> = {
 *   MERCHANT: 1.05,
 *   SHEPHERD: 1.0,
 *   SAGE: 1.0,
 *   ROGUE: 1.0,
 *   WARRIOR: 1.0,
 *   CLERIC: 1.0,
 *   MYSTIC: 1.0,
 *   WAR_HERO: 1.0,
 * };
 *
 * export const DRAGON_INCOME_MOD = 1.05; // Dragon hoard
 */
